/* PabDer — cart qty steppers */
(function(){
  function init(){
    var form=document.getElementById('cartForm');
    if(!form) return;
    form.querySelectorAll('.qty').forEach(function(q){
      var input=q.querySelector('input');
      q.querySelectorAll('[data-step]').forEach(function(btn){
        btn.addEventListener('click',function(){
          var v=parseInt(input.value,10)||0;
          v=Math.max(0,v+parseInt(btn.dataset.step,10));
          input.value=v;
          form.requestSubmit ? form.requestSubmit(form.querySelector('[name=update]')) : form.submit();
        });
      });
    });
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();
